import React from 'react';
import HeroContent from './HeroContent';
import './Hero.css';

const Hero = () => <HeroContent />;

export default Hero;
